module.exports = __webpack_public_path__ + "ed06a9de205ca94098417293a7880a7f.MP3";